import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { tableCellSelector, tableHeaderSelector, tablePrefixSelector } from '@atlaskit/adf-schema';
import { TableSharedCssClassName } from '@atlaskit/editor-common/styles';
export var RESIZE_HANDLE_AREA_DECORATION_GAP = 30;

/*
 * This type represents the start and end from a cell in a column,
 * for example, on this table the cell C1 will have
 * `left: 1` and `right: 3`.
 *
 * ```
 *      left          right
 *        1             3
 *        |             |
 *        |             |
 *        |             |
 * _______∨_____________∨_______
 * |      |             |      |
 * |  B1  |     C1      |  A1  |
 * |______|______ ______|______|
 * |             |      |      |
 * |     B2      |  D1  |  A2  |
 * |______ ______|______|______|
 * |      |      |             |
 * |  B3  |  C2  |      D2     |
 * |______|______|_____________|
 * ```
 *
 */

export var TableDecorations = /*#__PURE__*/function (TableDecorations) {
  TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
  TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
  TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
  TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
  TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
  TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
  TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
  TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
  TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
  TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
  return TableDecorations;
}({});
export var TableCssClassName = _objectSpread(_objectSpread({}, TableSharedCssClassName), {}, {
  COLUMN_CONTROLS: "".concat(tablePrefixSelector, "-column-controls"),
  COLUMN_CONTROLS_DECORATIONS: "".concat(tablePrefixSelector, "-column-controls-decoration"),
  COLUMN_SELECTED: "".concat(tablePrefixSelector, "-column__selected"),
  ROW_CONTROLS_WRAPPER: "".concat(tablePrefixSelector, "-row-controls-wrapper"),
  ROW_CONTROLS: "".concat(tablePrefixSelector, "-row-controls"),
  ROW_CONTROLS_INNER: "".concat(tablePrefixSelector, "-row-controls__inner"),
  ROW_CONTROLS_BUTTON_WRAP: "".concat(tablePrefixSelector, "-row-controls__button-wrap"),
  ROW_CONTROLS_BUTTON: "".concat(tablePrefixSelector, "-row-controls__button"),
  CONTROLS_BUTTON: "".concat(tablePrefixSelector, "-controls__button"),
  CONTROLS_BUTTON_ICON: "".concat(tablePrefixSelector, "-controls__button-icon"),
  CONTROLS_INSERT_BUTTON: "".concat(tablePrefixSelector, "-controls__insert-button"),
  CONTROLS_INSERT_BUTTON_INNER: "".concat(tablePrefixSelector, "-controls__insert-button-inner"),
  CONTROLS_INSERT_BUTTON_WRAP: "".concat(tablePrefixSelector, "-controls__insert-button-wrap"),
  CONTROLS_INSERT_LINE: "".concat(tablePrefixSelector, "-controls__insert-line"),
  CONTROLS_BUTTON_OVERLAY: "".concat(tablePrefixSelector, "-controls__button-overlay"),
  LAYOUT_BUTTON: "".concat(tablePrefixSelector, "-layout-button"),
  CONTROLS_INSERT_MARKER: "".concat(tablePrefixSelector, "-controls__insert-marker"),
  CONTROLS_INSERT_COLUMN: "".concat(tablePrefixSelector, "-controls__insert-column"),
  CONTROLS_INSERT_ROW: "".concat(tablePrefixSelector, "-controls__insert-row"),
  CONTROLS_DELETE_BUTTON_WRAP: "".concat(tablePrefixSelector, "-controls__delete-button-wrap"),
  CONTROLS_DELETE_BUTTON: "".concat(tablePrefixSelector, "-controls__delete-button"),
  CONTROLS_FLOATING_BUTTON_COLUMN: "".concat(tablePrefixSelector, "-controls-floating__button-column"),
  CONTROLS_FLOATING_BUTTON_ROW: "".concat(tablePrefixSelector, "-controls-floating__button-row"),
  CORNER_CONTROLS: "".concat(tablePrefixSelector, "-corner-controls"),
  CORNER_CONTROLS_INSERT_ROW_MARKER: "".concat(tablePrefixSelector, "-corner-controls__insert-row-marker"),
  CORNER_CONTROLS_INSERT_COLUMN_MARKER: "".concat(tablePrefixSelector, "-corner-controls__insert-column-marker"),
  CONTROLS_CORNER_BUTTON: "".concat(tablePrefixSelector, "-corner-button"),
  NUMBERED_COLUMN: "".concat(tablePrefixSelector, "-numbered-column"),
  NUMBERED_COLUMN_BUTTON: "".concat(tablePrefixSelector, "-numbered-column__button"),
  HOVERED_COLUMN: "".concat(tablePrefixSelector, "-hovered-column"),
  HOVERED_ROW: "".concat(tablePrefixSelector, "-hovered-row"),
  HOVERED_TABLE: "".concat(tablePrefixSelector, "-hovered-table"),
  HOVERED_CELL: "".concat(tablePrefixSelector, "-hovered-cell"),
  HOVERED_CELL_IN_DANGER: 'danger',
  HOVERED_CELL_ACTIVE: 'active',
  HOVERED_CELL_WARNING: "".concat(tablePrefixSelector, "-hovered-cell__warning"),
  HOVERED_DELETE_BUTTON: "".concat(tablePrefixSelector, "-hovered-delete-button"),
  WITH_CONTROLS: "".concat(tablePrefixSelector, "-with-controls"),
  RESIZING_PLUGIN: "".concat(tablePrefixSelector, "-resizing-plugin"),
  RESIZE_CURSOR: "".concat(tablePrefixSelector, "-resize-cursor"),
  IS_RESIZING: "".concat(tablePrefixSelector, "-is-resizing"),
  // Resize handle is going to be removed together with updateResizeHandles - table's utility function
  RESIZE_HANDLE: "".concat(tablePrefixSelector, "-resize-handle"),
  RESIZE_HANDLE_DECORATION: "".concat(tablePrefixSelector, "-resize-decoration"),
  CONTEXTUAL_SUBMENU: "".concat(tablePrefixSelector, "-contextual-submenu"),
  CONTEXTUAL_MENU_BUTTON_WRAP: "".concat(tablePrefixSelector, "-contextual-menu-button-wrap"),
  CONTEXTUAL_MENU_BUTTON: "".concat(tablePrefixSelector, "-contextual-menu-button"),
  CONTEXTUAL_MENU_BUTTON_FIXED: "".concat(tablePrefixSelector, "-contextual-menu-button-fixed"),
  CONTEXTUAL_MENU_ICON: "".concat(tablePrefixSelector, "-contextual-submenu-icon"),
  // come from prosemirror-table
  SELECTED_CELL: 'selectedCell',
  // defined in ReactNodeView based on PM node name
  NODEVIEW_WRAPPER: 'tableView-content-wrap',
  TABLE_SELECTED: "".concat(tablePrefixSelector, "-table__selected"),
  TABLE_CELL: tableCellSelector,
  TABLE_HEADER_CELL: tableHeaderSelector,
  TABLE_STICKY: "".concat(tablePrefixSelector, "-sticky"),
  TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
  LAST_ITEM_IN_CELL: "".concat(tablePrefixSelector, "-last-item-in-cell"),
  WITH_RESIZE_LINE: "".concat(tablePrefixSelector, "-column-resize-line"),
  WITH_RESIZE_LINE_LAST_COLUMN: "".concat(tablePrefixSelector, "-column-resize-line-last-column")
});
export var ShadowEvent = /*#__PURE__*/function (ShadowEvent) {
  ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
  ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
  return ShadowEvent;
}({});